import { observable } from "mobx";

export class IReportVideo {
    id!: string;
    angle!: string;
    url!: string;
    posterUrl!: string;
    metaData?: IReportVideoMetaData;
    @observable selectedVideoSpeedRate?: number;
}

export interface IReportVideoMetaData {
    framesPerSecond?: number;
    speedFactor?: number;
    duration?: string;
    height?: number;
    width?: number;
}